import { render, staticRenderFns } from "./MsotEditAbout.vue?vue&type=template&id=9a0b35fe&scoped=true&"
import script from "./MsotEditAbout.vue?vue&type=script&lang=js&"
export * from "./MsotEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0b35fe",
  null
  
)

export default component.exports